import React from "react";
import dayjs from "dayjs";
import CheckCircleSharp from "@mui/icons-material/CheckCircleSharp";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CircularProgress from "@mui/material/CircularProgress";
//import ThumbUpIcon from "@mui/icons-material/ThumbUp";
//import ThumbDownIcon from "@mui/icons-material/ThumbDown";
//import Live from "./Live";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";

/*const getMatchOutcome = (chunks) => {
  const firstScore = Number(chunks[0]);
  const secondScore = Number(chunks[1]);

  if (firstScore > secondScore) {
    return 1;
  } else if (firstScore === secondScore) {
    return 0;
  } else {
    return 2;
  }
}; */

/*const getResult = (value, finalScore) => {
  const valueChunks = value.split(":");
  const finalScoreChunks = finalScore.split(":");

  const valueOutcome = getMatchOutcome(valueChunks);
  const actualOutcome = getMatchOutcome(finalScoreChunks);

  if (valueOutcome === actualOutcome) {
    return (
      <>
        <div className="flex justify-center relative text-2xl top-0 text-primary">
          <span className="text-primary relative h-12 flex items-center justify-center">
            <ThumbUpIcon className="!text-4xl" />
          </span>
        </div>
        <div className="relative text-xs font-bold top-1.5"></div>
      </>
    );
  } else {
    return (
      <>
        <div className="relative text-2xl text-primary flex justify-center top-0">
          <span className="text-primary relative h-12 flex items-center justify-center">
            <ThumbDownIcon className="!text-4xl" />
          </span>
        </div>
        <div className="relative text-xs font-bold top-1.5"></div>
      </>
    );
  }
}; */

const getProbe = (pts) => {
  let probe = <></>;
  if (pts === undefined) {
    probe = null;
  } else if (pts === 1) {
    probe = <SportsSoccerIcon />;
  } else if (pts === 0) {
    probe = null;
  }
  return probe;
};

const Deadline = ({
  index,
  finalScore,
  value,
  pts,
  live,
  deadline,
  loading,
  justSaved,
  justError,
  gameNumber,
}) => {
  const isCalculated = finalScore && pts !== undefined;

  return (
    <div className="flex items-center justify-between w-full">
      {isCalculated ? (
        <div className="bg-cyan top-1 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-primary p-1 relative w-32">
          <DoneAllIcon className="ml-[8px] mr-[12px] text-lg relative -top-0.5" />
          {finalScore}
        </div>
      ) : live ? (
        <div className="bg-red top-1 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-white p-1 relative w-32">
          <OnlinePredictionIcon className="ml-[8px] mr-[12px] text-lg relative -top-0.5" />
          {finalScore || "LIVE"}
        </div>
      ) : (
        <>
          <div className="bg-gold top-1 rounded-[20px_194px_0px_0px/21px_119px_1px_0px] text-black p-1 relative w-48 md:w-44">
            <div className="relative text-primary text-base">
              <EventAvailableIcon className="ml-[8px] mr-0.5 text-lg! relative" />
              {dayjs(deadline).locale("uk").format("DD")}{" "}
              {dayjs(deadline).locale("uk").format("MMM")}{" "}
              {dayjs(deadline).locale("uk").format("HH:mm")}
            </div>
          </div>
        </>
      )}
      <div className="transform scale-[1.3] flex justify-center font-bold relative left-1 h-10 flex-col items-center mr-[38px]">
        {!loading && !justSaved && !justError && getProbe(pts)}
        {loading && (
          <CircularProgress className="bg-transparent !w-7 !h-7 !text-4xl p-1 mt-0.5 rounded-full !flex relative !text-white" />
        )}
        {justSaved && (
          <CheckCircleSharp className="bg-transparent !w-7 !h-7 !text-4xl  p-1 mt-0.5 rounded-full !flex relative !text-gold" />
        )}
        {justError && (
          <CancelRoundedIcon className="bg-transparent !w-7 !h-7 !text-4xl p-1 mt-0.5 rounded-full !flex relative !text-red" />
        )}
      </div>
    </div>
  );
};

export default Deadline;
